import { Injectable } from '@angular/core';
import { AccountInfo } from '@azure/msal-browser';
import { BehaviorSubject } from 'rxjs';
import { ToastBarService } from './toast-bar.service';

@Injectable({
  providedIn: 'root',
})
export class AccountInfoService {
  constructor(private toastBarService: ToastBarService) {}

  private accountInfoSource = new BehaviorSubject<AccountInfo | undefined>(
    undefined
  );
  accountInfo$ = this.accountInfoSource.asObservable();

  private userRoles = new BehaviorSubject<string[]>([]);
  userRolesData$ = this.userRoles.asObservable();

  updateData(newData: AccountInfo | undefined) {
    this.accountInfoSource.next(newData);
  }

  getCurrentUser(): AccountInfo | undefined {
    return this.accountInfoSource.value;
  }

  setUserRoles(userRole: string): void {
    const currentUserRoles = this.userRoles.getValue();
    this.userRoles.next([...currentUserRoles, userRole]);
  }

  /**
   * Checks if the current user has at least one of the required roles.
   *
   * @param requiredUserRoles - An array of role names that are required for access.
   * @param notifyUser - True if you want to notify the user that he can't perform an action.
   * @returns `true` if the user has at least one of the required roles, otherwise `false`.
   */
  checkUserRoles(requiredUserRoles: string[], notifyUser: boolean = false): boolean {
    const userRoles = this.userRoles.getValue();

    const canAccess = userRoles.some((role) =>
      requiredUserRoles.includes(role)
    );

    if (!canAccess && notifyUser) {
      this.toastBarService.showToast({
        severity: 'error',
        summary: 'Error',
        detail: `You don't have the required role!`,
      });
    }

    return canAccess;
  }
}
